import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/8aJvbganw2G3gT2FtxSoNX/Mockup_-_SN13_(1x1).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-66" data-mp="4lyvmmybwge6">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-67" data-mp="1297cu5rar3ad" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-68" data-mp="xae74zi94gkr">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-69" data-mp="xb5slhi4wxxb">
          🌿 BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-70" data-mp="3d1ikl9ryvcnf">
          Desinflamá la panza para siempre en 28 días{' '}
          <span className="text-brand-light" data-id="element-71" data-mp="3j9aldp7jncay">sin dietas imposibles ni suplementos caros.</span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-72" data-mp="3o59bpicfn4e0">
          <img src={mockupUrl} alt="Mockup del Protocolo Intestino en Paz" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-73" data-mp="3e7uydrlt2vpx" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-74" data-mp="35a2jgojzxq32">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-75" data-mp="2vietyt702j48">PROTOCOLO INTESTINO EN PAZ™</p>
          <p className="-mb-4 mt-3 text-slate-200 sm:text-base font-[300] text-[14px]" data-id="element-76" data-mp="2hjoz7k7nkvj1">
            Diseñado para hombres y mujeres de 30 a 55 años que quieren recuperar la ligereza, sin pastillas ni restricciones extremas.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-77" data-mp="nbbc4wdi0748">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="ibp0ush8d0y2"><FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-79" data-mp="ddwwv03b9odi" />100% PDF</span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-80" data-mp="1b0nhtm9m9x1s"><ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-81" data-mp="161ayhbhyf83y" />Acceso en 5 min</span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-82" data-mp="111y9ak3m1oy7">
          <ActionButton href="#pricing" showTrust data-id="element-83" data-mp="x3h6gcr830ml">🌿 QUIERO MI PROTOCOLO AHORA</ActionButton>
        </motion.div>
      </div>
    </section>;
}